import { EmployeeFreebiesAssignRequest } from "./dto/employee-freebies-assign.request";
import { EmployeeFreebiesEntity } from "./entity/employee-freebies.entity";
import { Inject, Injectable } from "@nestjs/common";
import { FreebiesConsumptionEntity } from "./entity/freebies-consumption.entity";
import { EmployeeFreebieModel } from "@gtpl/shared-models/canteen-management";

@Injectable()
export class TokensAdapter {

    /**
     * convert the dto to entity
     * @param employeeFreebieReq 
     * @returns 
     */
    convertEmpFreebieDtoToEntity(employeeFreebieReq: EmployeeFreebiesAssignRequest): EmployeeFreebiesEntity {
        const empFreebieEnt = new EmployeeFreebiesEntity();
        empFreebieEnt.employeeFreebiesId = employeeFreebieReq.employeeFreebiesId;
        empFreebieEnt.freebieId = employeeFreebieReq.freebieId;
        empFreebieEnt.freebieCode = employeeFreebieReq.freebieCode;
        empFreebieEnt.employeeCode = employeeFreebieReq.employeeCode;
        empFreebieEnt.originalCount = employeeFreebieReq.freebieCount;
        empFreebieEnt.availableCount = employeeFreebieReq.freebieCount;
        empFreebieEnt.createdUser = employeeFreebieReq.username;
        empFreebieEnt.year = employeeFreebieReq.year;
        empFreebieEnt.month = employeeFreebieReq.month;
        empFreebieEnt.maxConsumptionPerDay = employeeFreebieReq.maxConsumptionPerDay;
        empFreebieEnt.employeeId = employeeFreebieReq.employeeId;
        return empFreebieEnt;
    }

    /**
     * converts the entity to dto
     * @param empFreebieEnt 
     * @returns 
     */
    convertEmpFreebieEntityToDto(empFreebieEnt: EmployeeFreebiesEntity): EmployeeFreebieModel {
        return new EmployeeFreebieModel(
            empFreebieEnt.employeeFreebiesId, empFreebieEnt.employeeCode, empFreebieEnt.freebieCode, empFreebieEnt.createdUser, empFreebieEnt.originalCount, empFreebieEnt.year, empFreebieEnt.month, empFreebieEnt.maxConsumptionPerDay, empFreebieEnt.employeeId, empFreebieEnt.freebieId, empFreebieEnt.availableCount,empFreebieEnt.isActive
        );
    }

    /**
     * 
     * @param empId 
     * @param empCode 
     * @param empFbId 
     * @param freebieCode 
     * @param rfCode 
     * @param year 
     * @param month 
     * @param deviceCode 
     * @param username 
     * @param deptId 
     * @param freebieCat 
     * @param price
     * @param isActive
     * @returns 
     */
    getFreebiesConsumptionEntity(empId: number, empCode: string, empFbId: number, freebieCode: string, rfCode: string, year: number, month: number, deviceCode: string, username: string, deptId: number, freebieCat: string, price: number,isActive:boolean): FreebiesConsumptionEntity {
        const freebieConsEnt = new FreebiesConsumptionEntity();
        freebieConsEnt.employeeId = empId;
        freebieConsEnt.employeeCode = empCode;
        freebieConsEnt.employeeFreebiesId = empFbId;
        freebieConsEnt.freebieCode = freebieCode;
        freebieConsEnt.rfCode = rfCode;
        freebieConsEnt.year = year;
        freebieConsEnt.month = month;
        freebieConsEnt.deviceCode = deviceCode;
        freebieConsEnt.createdUser = username;
        freebieConsEnt.departmentId = deptId;
        freebieConsEnt.freebieCategory = freebieCat;
        freebieConsEnt.unitPrice = price;
        freebieConsEnt.isActive = isActive;
        return freebieConsEnt;
    }
}